import { Popover } from 'module/ui/components/atoms/popover';
import { CitationType } from 'api/citation/types';
import { useState } from 'react';
import styled from 'styled-components';
import { CitationKnowledgeDocumentPopover } from './popovers/knowledge-document';
import { CitationMeetingPagePopover } from './popovers/meeting-page';
import { OnViewCitationSourceCallback } from './types';

interface CitationDataPopoverProps {
  citationId: number;
  label?: string;
  citationType: CitationType;
  onViewCitationSource?: OnViewCitationSourceCallback;
}

const CitationNumber = styled.span<{ isHovered: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 15px;
  background-color: ${({ isHovered }) =>
    isHovered ? 'var(--brand-color)' : 'var(--scarlet-gray-70)'};
  border-radius: 50%;
  font-size: 0.56rem;
  color: ${({ isHovered }) =>
    isHovered ? 'var(--white-100)' : 'var(--text-secondary)'};
  line-height: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: 0.2rem;
  position: relative;
  top: -2px;

  &:hover {
    background-color: var(--brand-color);
    color: var(--white-100);
  }
`;

const StyledPopover = styled(Popover)`
  vertical-align: middle;
`;

export const CitationDataPopover: React.FC<CitationDataPopoverProps> = ({
  citationId,
  citationType,
  label,
  onViewCitationSource,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const CitationPopoverMappping = {
    [CitationType.Meeting]: CitationMeetingPagePopover,
    [CitationType.Email]: CitationMeetingPagePopover,
    [CitationType.KnowledgeDocument]: CitationKnowledgeDocumentPopover,
  };

  const CitationPopover = CitationPopoverMappping[citationType];

  // If no valid citation type or component, just render the label without popover
  if (!citationType || !CitationPopover) {
    return <CitationNumber isHovered={isHovered}>{label}</CitationNumber>;
  }

  return (
    <StyledPopover
      open={isHovered}
      onOpenChange={setIsHovered}
      placement="bottom"
      content={
        <CitationPopover
          citationId={citationId}
          onViewCitationSource={onViewCitationSource}
        />
      }
    >
      <CitationNumber isHovered={isHovered}>{label}</CitationNumber>
    </StyledPopover>
  );
};
